import { createGenericFetchMachine } from '@/common/overmind/machines/generic-fetch-machine';

import * as actions from './actions';
import type { MapConfiguration } from './config.types';

const state = createGenericFetchMachine<MapConfiguration>();

type ArcGISConfigurationState = typeof state;

export function isWebmapAvailable(
  arcgisConfiguration: ArcGISConfigurationState
): arcgisConfiguration is Extract<
  ArcGISConfigurationState,
  { current: 'LOADED' }
> & { value: NonNullable<MapConfiguration['map']['webMap']> } {
  return (
    arcgisConfiguration.current === 'LOADED' &&
    arcgisConfiguration.value?.map.webMap !== undefined
  );
}

export { state, actions };
